/* eslint-disable no-console */
import { useGetZone } from "@app/store/service/cmsService"
import { appStore } from "@app/store/store"
import { Image, useViewport } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import React from "react"
import { ContentBody } from "../../core/ContentBody/ContentBody"
import { ContentHeader } from "../../core/ContentHeader/ContentHeader"
import { InfoHeader } from "../../core/InfoHeader/InfoHeader"
import Page from "../Page/Page"

export default function ImagePage({ children, imgSrc, allowUnknownTypes }) {
	const { sm, md } = useViewport()

	let info = null
	let header = null
	let content = null
	let footer = null
	let unkownTypes = []

	const { data: zone } = useGetZone(useSelector(state => state.core.zoneId))
	const { image: zoneImg } = zone || {
		image: "https://funnel.cms.tecreation.de/assets/EA8E7FFA-EBF4-4C28-B156-84B78C6E12FB?access_token=" + appStore.get("settings.cmsKey"),
	}
	const defaultImg = zoneImg

	React.Children.forEach(children, e => {
		if (!e) {
			return
		}

		if (e.type === InfoHeader)
			info = React.cloneElement(e, {
				...e.props,
				backgroundColor: zone.color,
			})
		else if (e.type === ContentHeader) header = e
		else if (e.type === ContentBody) content = e
		// eslint-disable-next-line no-dupe-else-if
		else if (e.type === ContentHeader) footer = e
		else if (!allowUnknownTypes) console.error("unsupported child element " + e.type)
		else unkownTypes.push(e)
	})

	if (imgSrc) {
		console.warn("current imageSrc property will be ignored. We use the same image of a zone for all pages")
	}

	return (
		<Page className="loginPage flex flex-column flex-lg-row">
			{!sm && !md && (
				<div className="flex flex-column" style={{ width: "40%" }}>
					{info}
					<div className="fill h-100">
						<Image
							asBackground
							src={defaultImg}
							style={{
								width: "100%",
								height: "100%",
								backgroundSize: "cover",
							}}
						/>
					</div>
				</div>
			)}

			<div className="rounded-top-3 rounded-top-lg-0 flex-1 flex flex-column h-100 of-hidden relative">
				<div className="fill h-100 color-bg-default relative flex flex-column">
					{header}
					{content}
					{footer}
					{unkownTypes}
				</div>
			</div>
		</Page>
	)
}
